<template>
  <div></div>
</template>

<script>
const CLOSED_STATUSES = ['Cerrado', 'Cierre Operativo'];
const CANCELLED_STATUSES = [
  'Cancelado',
  'Cancel Requiered',
  'Cancelacion Requerida',
  'Cancel With Charge',
  'Cancel No Charge',
  'Cancel Required',
];

export default {
  name: 'BaseItineraryPage',
  data() {
    return {
      showModal: false,
      loading: true,
      loadingNotes: true,
      status: '',
      expiredDays: null,
      expiredDaysDefault: null,
    };
  },
  computed: {
    ready() {
      return !this.loading && !this.loadingNotes;
    },
    isOpen() {
      return !CLOSED_STATUSES.includes(this.status) && !CANCELLED_STATUSES.includes(this.status);
    },
    isClosed() {
      return CLOSED_STATUSES.includes(this.status);
    },
    isCancelled() {
      return CANCELLED_STATUSES.includes(this.status);
    },
    fitStatus() {
      return this.$store.state.fitStatus;
    },
    viewOnlyInQuote() {
      return this.isOpen && this.fitStatus === 'Quote';
    },
    isUser() {
      return this.$store.state.isUser;
    },
    modifiedUTCDate() {
      return new Date(this.$store.state.modifiedUTC);
    },
    isExpired() {
      const days = this.expiredDays || this.expiredDaysDefault || 15;
      this.$store.commit('setExpireDays', days);
      return this.fitStatus === 'Quote'
        && this.modifiedUTCDate
        && new Date() - this.modifiedUTCDate > days * 24 * 60 * 60 * 1000;
    },
  },
  methods: {
    openSpecialistModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    handleEscKey(event) {
      if (event.key === 'Escape' && this.showModal) {
        this.closeModal();
      }
    },
    tr(key) {
      return this.$root.tr(key);
    },
  },
  watch: {
    showModal(show) {
      if (show) {
        document.addEventListener('keydown', this.handleEscKey);
      } else {
        document.removeEventListener('keydown', this.handleEscKey);
      }
    },
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleEscKey);
  },
};
</script>
